module.exports = __webpack_public_path__ + "static/img/Zeke-Uwland.2b53e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zeke-Uwland.jpg
// module id = YkiS
// module chunks = 0